module.exports = __webpack_public_path__ + "assets/img/1.744c2f29.png";